/** @internal */
export function getSorted(value: any): any {
    if (!(value && !Array.isArray(value) && typeof value === 'object')) {
        return value
    }

    if (Array.isArray(value)) {
        return value.map(getSorted)
    }

    const sorted: any = {}
    Object.keys(value)
        .sort()
        .forEach((key) => {
            sorted[key] = getSorted(value[key])
        })

    return sorted
}
